import styled from 'styled-components'

// Wrapper
export const TableActionWrapper = styled.div`
  /* Parent
  ------------------------------- */
  width: 100%;

  /* Childrens
  ------------------------------- */
  .table-action-right {}

  .table-action-left {}

  /* Modifiers
  ------------------------------- */
  &.is-vertical-align-bottom {
    > .grid-base {
      > .grid-container-base {
        align-items: flex-end;
      }
    }
  }

  /* Media queries
  ------------------------------- */
`
